import request from "./request"

export const getNotifications = params => request({ url: "/notification/list_get", method: "get", params })
export const getNotificationUnread = () => request({ url: "/notification/unread_get", method: "get" })
export const getNotificationPopups = params => request({ url: "/notification/popup_get", method: "get", params })
export const markNotificationRead = data => request({ url: "/notification/read_update", method: "post", data })
export const markAllNotificationsRead = data => request({ url: "/notification/read_all", method: "post", data })
export const getNotificationPreferences = () => request({ url: "/notification/preference_get", method: "get" })
export const updateNotificationPreference = data => request({ url: "/notification/preference_update", method: "post", data })
